/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TShareFolderOffersModel,
  IShareFolderOffersRequest,
  IMappers,
  IShareFolderOffersResponse,
  IShareFolderOffersResponseError,
  TShareFolderOffersResponse,
} from './types';

const defaultConfig: TShareFolderOffersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'favorites',
  pathApi: '/v1/share-folder-offers/',
  hostType: 'api',
} as TShareFolderOffersModel;

function createShareFolderOffersModel(parameters: IShareFolderOffersRequest): TShareFolderOffersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IShareFolderOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IShareFolderOffersRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchShareFolderOffers<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IShareFolderOffersOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TShareFolderOffersResponse
> {
  const { response, statusCode } = await httpApi.fetch(createShareFolderOffersModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IShareFolderOffersResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IShareFolderOffersResponseError);
    }
  }

  return { response, statusCode } as TShareFolderOffersResponse;
}

export { defaultConfig, createShareFolderOffersModel, fetchShareFolderOffers };
